/**
 * JSON-LD helpers.
 *
 * Keeps exactly one JSON-LD script tag per id and updates it on navigation.
 */

export function upsertJsonLd(id, data) {
  if (!id) return;

  const scriptId = id;
  let script = document.getElementById(scriptId);

  if (!data) {
    if (script) script.remove();
    return;
  }

  const json = JSON.stringify(data);

  if (!script) {
    script = document.createElement("script");
    script.id = scriptId;
    script.type = "application/ld+json";
    document.head.appendChild(script);
  }

  // Avoid innerHTML; textContent is safer.
  script.textContent = json;
}

export function removeJsonLd(id) {
  if (!id) return;
  const script = document.getElementById(id);
  if (script) script.remove();
}
